import React from "react";
import { useState } from "react";
import { Link } from "react-scroll";
import "../style/header.css";
import Darkreader from "react-darkreader";
import Hamburger from "./Hamburger";

const Header = () => {
  const [hamburger, setHamburger] = useState(false);
  const toggleHamburger = () => {
    setHamburger(!hamburger);
  };
  return (
    <header className="header">
        <i className="fas fa-bars" onClick={toggleHamburger}></i>
      <div className="header-list">
        <Link
          className="vinculo-header"
          to="about"
          smooth={true}
          duration={800}
        >
          ABOUT
        </Link>
        <Link
          className="vinculo-header"
          to="portfolio"
          smooth={true}
          duration={800}
        >
          PORTFOLIO
        </Link>
        <Link
          className="vinculo-header"
          to="contacto"
          smooth={true}
          duration={800}
        >
          CONTACTO
        </Link>
      </div>
      <div className="theme-icon">
        <Darkreader />
      </div>
      <Hamburger hamburger={hamburger} toggleHamburger={toggleHamburger} />
    </header>
  );
};

export default Header;
